const BACKEND_URL = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" ? 'http://localhost:5000' : 'https://kga-staging.formationscorp.com';


//TODO: Need to catch auth token timeouts and either create a new token, or logout the user.
const handleResponse = async (response) => {
    if(response.status === 401){
        window.location.reload();
        return;
    }

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
};

export const fetchAllDocuments = async () => {
    console.log("Fetching all documents from", BACKEND_URL);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include' 
    };
    const response = await fetch(`${BACKEND_URL}/get-all-data`, requestOptions);
    return handleResponse(response);
};

export const searchDocuments = async (query) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query }),
        credentials: 'include'  
    };

    const response = await fetch(`${BACKEND_URL}/search`, requestOptions);
    return handleResponse(response);
};

export const pivotDocuments = async (doc) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: doc.question, answer: doc.answer}),
        credentials: 'include'  
    };

    const response = await fetch(`${BACKEND_URL}/pivot`, requestOptions);
    return handleResponse(response);
};

export const generateBlog = async (questionAndAnswers) => {
    try{
        const response = await fetch(`${BACKEND_URL}/generate-blog`, {
            method: 'POST',
            headers: {'Content-Type' : 'application/json'},
            body: JSON.stringify(questionAndAnswers),
            credentials: 'include'  
        });

        const data = await response.json();
        return data;

    }catch (error){
        console.error('Error generating blog: ', error);
        throw error;
    }
    
};

export const consolidate = async (questionsAndAnswers, tags) => {
    console.log("Sending")
    try{
        const requestOptions = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({questionsAndAnswers, tags}),
            credentials: 'include'  
        };

        const response = await fetch(`${BACKEND_URL}/consolidate`, requestOptions);
        const data = await response.json();
        return data;
    }catch (error){
        console.error('Error Consolidating: ', error);
        throw error;
    }
}

export const generateKGAFromBlog = async (url) => {
    try{
        const requestOptions = {
            method: 'Post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({input : url}),
            credentials: 'include'  
        };
        const response = await fetch(`${BACKEND_URL}/generate-kga-from-blog`, requestOptions);
        return await handleResponse(response);
    }catch{

    }
}

export const update = async (updatedDocument) => {
    try {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedDocument),
            credentials: 'include'  
          };

          const response = await fetch(`${BACKEND_URL}/update`, requestOptions);
          return await handleResponse(response);
    }catch (error){
        console.log('Error updating: ', error);
        throw error;
    }
}

export const deleteDocuments = async (idsToDelete) => {
    try {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ids: idsToDelete }),
            credentials: 'include'  
        };
        const response = await fetch(`${BACKEND_URL}/delete-documents`, requestOptions);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await handleResponse(response);
    } catch (error) {
        console.error('Error deleting documents:', error);
        throw error; 
    }
};

export const validatePasscode = async (passcode) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ passcode }),
        credentials: 'include'
      };
      const response = await fetch(`${BACKEND_URL}/validate-passcode`, requestOptions);
      return await handleResponse(response);
    } catch (error) {
      console.error('Error wrong passcode:', error);
      throw error;
    }
  };


  